import { NgModule } from '@angular/core';
import { NgxSelectboxMayComponent } from './ngx-selectbox-may.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NGXSelectboxMayPipe } from './NGXSelectboxMayPipe';

@NgModule({
  declarations: [NgxSelectboxMayComponent, NGXSelectboxMayPipe],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule
  ],
  exports: [NgxSelectboxMayComponent]
})
export class NgxSelectboxMayModule { }
